import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e20fa618"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["title"]

import { computed, PropType, ref, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import ExpandableText from '@/components/ExpandableText.vue';
import { MemberRole } from '@/Member/member.entity';


export default /*#__PURE__*/_defineComponent({
  __name: 'MemberBadge',
  props: {
    role: {
        type: String as PropType<MemberRole>,
        required: true,
    },
    disableRoleExpansion: {
        type: Boolean,
        default: false,
    },
},
  setup(__props) {

const props = __props;

const memberRole = ref<InstanceType<typeof ExpandableText>>();



const { role, disableRoleExpansion } = toRefs(props);

const { t } = useI18n();

const badgeType = computed<'primary' | 'danger'>(() => {
    return role.value === MemberRole.ADMIN ? 'danger' : 'primary';
});

const title = computed(() => {
    return t('listMembers.roles.' + role.value);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("sup", {
    class: _normalizeClass(["member-badge", [`member-badge--${badgeType.value}`]]),
    title: title.value,
    onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (memberRole.value?.expand())),
    onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (memberRole.value?.collapse()))
  }, [
    _createVNode(ExpandableText, {
      ref_key: "memberRole",
      ref: memberRole,
      text: title.value,
      "disable-hover": "",
      "disable-expansion": _unref(disableRoleExpansion)
    }, null, 8, ["text", "disable-expansion"])
  ], 42, _hoisted_1))
}
}

})